import React, {useCallback, useState} from 'react';
import type {NationalAgent} from 'services/agent/types';
import {useLocalization} from 'localization';
import {useLazyGetAgentNorafDryRunQuery} from 'services/agent/agentApi';
import {ActionButtonV2} from 'components/button/ActionButtonV2';
import {PrettyPrintPopup} from 'components/prettyPrint';
import {useSnacks} from 'components/snacks';

type Props = {
  agent: NationalAgent;
};

export const NorafPreview: React.FC<Props> = ({agent}) => {
  const [openPreview, setOpenPreview] = useState(false);
  const [content, setContent] = useState('');

  const [trigger] = useLazyGetAgentNorafDryRunQuery();
  const {errorSnack} = useSnacks();
  const {t} = useLocalization();

  const loadPreviewContent = useCallback(() => {
    trigger({agent})
      .unwrap()
      .then(response => {
        setContent(JSON.stringify(response, null, 2));
        setOpenPreview(true);
      })
      .catch(error => {
        if (error.message) {
          errorSnack(t('error.api.AGENT_NOT_FOUND'), error);
        } else {
          errorSnack(t('error.api.unknown'), error);
        }
      });
  }, [agent, errorSnack, t, trigger]);

  return (
    <>
      <PrettyPrintPopup
        isOpen={openPreview}
        onClose={() => setOpenPreview(false)}
        content={content}
      />
      <ActionButtonV2
        variant="text"
        title={'Vis NORAF data'}
        icon={'Cartoon'}
        onClick={loadPreviewContent}
      />
    </>
  );
};
